<template>
    <div class="  con_content"  style="height:660px;overflow:auto;">
        
        <div class="" style="width:100%">
            
            <div >
                
                <!-- table组件 -->
                <div class="my_table">
                    
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10">所属类目 : &nbsp;</div> 
                                <div class="lft pointer" :class="[title_num == -1 ?'colorP':'']"  @click="title_num = -1;guid = 'better'"  > 推荐 </div>
                                <div class="lft pointer" v-for="(item,num) in titles" :class="[title_num == num?'colorP':'']"  @click="title_num = num;guid = item.guid" :key="num"> &nbsp; <span class="cBlack">/</span> &nbsp;{{item.name}} </div>
                                
                                                
                            </div> 
                             
                            <!-- <Button class="rgt mR20 top14" @click="route='/layout/circle/background/add';out_btnFun(null,0)"  type="info">添加背景图</Button> 
                            <Button class="rgt mR20 top14" @click="lookFun"  type="info">查看类目</Button>    -->
                        </Row>        
                    </div>
                  
                </div>
                <div class="my_table">
                    
                    <div class="my_search" >
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10 fw900 fon fs18">背景图列表 </div> 
                                       
                            </div> 
                            <Col span="4" class="listIpt rgt mR20">
                                <Input  ref='isFocuseA'    :maxlength='20' @keyup.enter.native="nameFun" v-model="name"  class='ipt   top13 '  placeholder="请输入背景图名"  >
                                    <Button size="small" @click='nameFun'   slot="append" icon="md-search"></Button>
                                </Input>
                            </Col>
                            
                        </Row>        
                    </div>

                </div>
                <div class="my_table lie">
                   
                    <div  v-for="(item,num) in data1" :key="num" :class="{'bg_box':true,'bg_box5':(num+1)%8 == 0}">
                        <img :src="item.url" alt="">
                        <div class="box">
                            <div class="box_c box_l">
                                <p><b class="fs14">{{item.name}}&nbsp;&nbsp;({{item.sort}})</b></p>
                                <p class="fs12" style="opacity:0.43">所属类目: {{item.backgroundTypeName}}</p>
                                <p class="fs10 " style="opacity:0.25">{{  item.createTime.split(" ")[0] }}</p>
                                <p v-if=" my_url != item.path " class="txt_c bottom10 top5"> <Button size="small"  type="info"  @click='my_url = item.path;backgroundFun()' >选择图片</Button> </p>
                                <p v-if=" my_url == item.path" class="txt_c bottom10 top5"> <Button size="small"  type="error"  @click='my_url = "";backgroundFun()' >选中图片</Button> </p>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <Footer class="bottom0">
                    <Page class="txt_c"  :current.sync="page" :total="total" :page-size='size' :page-size-opts='[8,16,24,32]'   @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer      />
                </Footer>
                
            </div>         
        </div>

    </div>
    
</template>
<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    
    
    import aplayer from 'vue-aplayer';
    export default {
        name:'recommend',
        data () {
            return {
                my_url: null,
                token: null,
                route: null,
                guid: 'better', 
                my_guid:null,
                titles: [],
                title_num: -1,
                //内容
                columns1:[],   
                data1:[],
                total: null,
                page:1,
                size: 8,
                //搜索
                search_page:1,
                search_size: 20,
                // 类目 
                columns:[],   
                data:[],
              
                // 主体编辑
                out_url: null,  //场景路径
                
                out_model1:null,  //场景名称
                out_model2:null,  //场景guid
                out_model3:0,  //场景排序
                out_model4:"0",  //是否推荐
                out_model5:"0",  //是否隐藏
                out_model6:0,     //收取孝心值
                

                // 类目编辑
                m_model1:null,  //分类名称
                m_model2:null,  //分类描述
                m_model3:null,  //分类排序
                m_model4:null,  //隐藏分类

                name: null,

                lo: false,
                out_btn: null,  
                out_guid: null,
                out_btn_num: null,
                out_title: null,
                out_succ: null,

                lm: false,     //是否弹出类目
                m_btn: false , //类目弹窗的按钮弹窗
                m_guid: null,
                m_btn_num: 0,
                m_title: "添加类目",
                m_succ: "添加",

                // 上传背景图
                up_data: null,
                file_name: null,
                file_path: null,

                child_val: null,  //child 反馈
            }
        },
     
        watch:{
           title_num(val){
               let that = this;
               that.load1();
           },
           child_bool(val,old){
               if(val != old){
                   
                   this.my_url = this.mbb_url;
                   this.load1();
                   
               }
           },
           mbb_url(val){
               let that = this;
               that.my_url = val;
               
           }
          
        },
        props:['mbb_url','child_bool'],
        components: {
          aplayer
        },
        computed: {
            
       
        },
        
        
        methods: {
            backgroundFun(){
                let that = this;
                that.$emit('background_val',that.my_url);
                that.$emit('background_open',false);
                this.$Message.info({
                    content:'选择背景成功',
                    duration:3 
                });
            },
            load(){
              let that = this;
              that.$myAjax.get('admin/service/admin/fame/background/type/image?type=0').then( res => {
                  that.titles = res.data.data;
                  
                  that.columns = [
                       {title:'排序',key:'sort',align:'center',width: 80},
                       {title:'名称',key:'name',align:'center',minWidth: 100,ellipsis: true},
                       {title:'分类描述',key:'content',align:'center',minWidth:150},
                       {title:'状态',key:'display',align:'center',width:'110',
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.display,
                                          'true-value': 0,
                                          'false-value': 1
                                      },
                                      on: {
                                          'on-change': (value) => {
                                             
                                              that.$myAjax.put(
                
                                                  'admin/service/admin/fame/background/type?route=/layout/circle/background/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "type": 0,
                                                      "display": value
                                                  },
                                                  
                                              ).then(res => {
                                                  that.load()
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                      },
                      {title:'添加时间',key:'createTime',align:'center',minWidth:130,maxWidth:190},
                      {title:'操作',slot:'btn',align:'center',width:160,fixed: 'right'}
                  ];
                  that.data = res.data.data;
                  
                  that.out_model2 = that.data[0].guid;
                  
              })
          },
          load1(){
            
              let that = this;
              let data = {
                  guid: that.guid,
                  page: that.page,
                  size: that.size,
                  type: 0

              };
              
              
              that.$myAjax.get('admin/service/admin/fame/background/all'+that.$ajaxNull.get(data)).then( res => {
                  
                  
                  that.data1 = res.data.data.list;
                  
                  that.page = res.data.data.pageNum;
                  that.size = res.data.data.pageSize;
                  that.total = res.data.data.total;

                  
              })
          },
          
          change_page(){
              this.load1();
          },
          change_size(size){
              this.size = size;
              this.load1();
          },
          


            
            // 搜索名称
            nameFun(){
                let that = this;
                let data = {
                  name: that.name,
                  page: that.search_page,
                  size: that.search_size,
                  type: 0

                };
                if(that.name){
                    that.$myAjax.get('admin/service/admin/fame/background/search'+that.$ajaxNull.get(data)).then( res => {
                        that.data1 = res.data.data.list;
                        that.page = res.data.data.pageNum;
                        that.size = res.data.data.pageSize;
                        that.total = res.data.data.total;
                    })
                }else{
                    that.load1();
                }
                
                
            },
            // 页面 switch
           change_out_zt(bool){
               let that = this;
               
               
               that.$myAjax.put(              
                    'admin/service/admin/background?route=/layout/circle/background/editor',
                    {
                        "guid": event.target.dataset.guid,
                        // "backgroundTypeGuid": event.target.dataset.bguid,
                        "type": 0,
                        "display": bool
                    }               
                ).then( res => {
                    that.load1();
            
                }).catch( err => {
                    console.log(err)
                })
            },
            // 弹窗switch
           change_out_isBetter(bool){
               this.out_model4 = bool;
               
            },
           change_out_display(bool){
               this.out_model5 = bool;
               
            },
            //   类目
            change_btn(bool){
               this.m_model4 = bool;
               
            },
            //   查看类目
           lookFun(){
               this.lm = true;
           },
            lookSucc(){
               this.lm = false;
            },
            
            

         
        },
        mounted: function(){
           let that = this;
           
           that.my_guid = that.$store.state.guid;
           
           that.token = that.$store.state.token;
           that.load();
           that.load1();

        }
    }
</script>
<style scoped>
    


    .lie{
       height: auto;
       overflow: hidden;
    }

    /* 图片box  */
   .bg_box{
       float: left;
       width: calc(12.5% - 11.75px);
       height:auto;
       margin-right: 13px;
       margin-bottom: 13px;  
       background: #fafafa; 
       border-radius: 3px;
       overflow: hidden;   
   }
   .bg_box5{   /** 每排第5个 **/
       margin-right: 0!important;
   }
   .bg_box img{
       width: 100%;
   }
   
   .bg_box .box{
       width: 100%;
       height: auto;
       padding: 6px 10px;
       
       overflow: hidden;
   }
   .bg_box .box_c{
       
   }
   .bg_box .box_c p{
       height: 22px;
   }
   .bg_box .box_l{
       float: left;
       text-align: left;
       width: 100%;
   }
   .bg_box .box_r{
       float: right;
       text-align: right;
   }
   .bg_box .box_r .br_edt{
       
       padding-right: 5px;
       color: #2d8cf0;
   }
   .bg_box .box_r .br_del{
     
       color: #2d8cf0;
   }

   /* 大图片 */
   .bg_pic{
       position: fixed;
       width: 400px;
       height: auto;
       margin-left: 300px;
       /* z-index: 999999; */
   }
   .bg_pic img{
       width: 100%;
       height: 100%;
   }

   
</style>